import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-academic',
  templateUrl: './academic.component.html',
  styleUrls: ['./academic.component.less']
})
export class AcademicComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
